import React, { FC } from 'react';

import { Typography, TypographyProps, useDesktop } from 'Modules/ui3';


export const Paragraph: FC<TypographyProps<'p'>> = ({ children, ...props }) => {
    const isDesktop = useDesktop();

    return (
        <Typography
            component='p'
            variant={isDesktop ? 'regularHeader2' : 'regularBody2'}
            lineHeight={isDesktop ? '1.5' : '1.4'}
            color='grayscale.shade95'
            mt={isDesktop ? 5 : 3}
            {...props}
        >
            {children}
        </Typography>
    );
};
